import type { ReactNode } from 'react';

import { cn } from '../utils/entry.js';

type CouponEventNumberProps = {
  eventNumber: number;
  className?: string;
};

/**
 * Component to display the event number in a coupon.
 *
 * @param param0 Props
 * @param param0.eventNumber The event number for the coupon row
 * @param param0.className Additional class names
 * @returns Component that display the event number in a coupon.
 */
export default function CouponEventNumber({ eventNumber, className }: CouponEventNumberProps): ReactNode {
  return (
    <div className={cn('text-layer-fg-muted leading-4 [grid-area:badge]', className)}>
      <span>{eventNumber}</span>
    </div>
  );
}
